import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import logo from "../../../assets/images/logo-cinzan-edu.png";

const ExportPDFPro = (data, filters) => {
  // --------------------
  // Paysage : orientation = "l"
  const doc = new jsPDF("l", "mm", "a4"); // "l" = landscape
  const pageWidth = doc.internal.pageSize.getWidth();

  // Logo
  const imgProps = doc.getImageProperties(logo);
  const imgWidth = 30;
  const imgHeight = (imgProps.height * imgWidth) / imgProps.width;
  doc.addImage(logo, "PNG", 10, 10, imgWidth, imgHeight);

  // Titre
  doc.setFontSize(16);
  doc.setFont("helvetica", "bold");
  doc.text("Liste des candidats", pageWidth / 2, 20, { align: "center" });

  // Date et heure
  const date = new Date().toLocaleString();
  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  doc.text(`Date d'export : ${date}`, pageWidth - 10, 10, { align: "right" });

  // Filtres appliqués
  const filterTexts = [];
  Object.keys(filters).forEach((key) => {
    const val = filters[key];
    if (val && typeof val === "object" && val.label) {
      filterTexts.push(`${key.replace(/_/g, " ")} = ${val.label}`);
    }
  });
  const appliedFilters = filterTexts.length ? filterTexts.join(", ") : "Aucun";
  doc.setFontSize(10);
  doc.text(`Filtres appliqués : ${appliedFilters}`, 10, 25);

  // Colonnes du tableau
  const tableColumn = [
    "ID",
    "Réf. Évaluation",
    "EC",
    "Matricule",
    "Nom et prénom",
    "Année académique",
    "Semestre",
    "Niveau d'étude"
  ];

  // Données
  const tableRows = [];
  if (!data || data.length === 0) {
    tableRows.push(["Aucun résultat trouvé"]);
  } else {
    data.forEach((record) => {
      const student = record.student || {};
      tableRows.push([
        record.id,
        record.evaluation?.title || "-",
        record.course_component?.code || "-",
        student.student_number || "-",
        `${student.first_name || ""} ${student.last_name || ""}`,
        record.academic_year?.name || "-",
        record.semester?.code || "-",
        record.study_level?.name || "-"
      ]);
    });
  }

  // Table autoTable
  autoTable(doc, {
    startY: 30,
    head: [tableColumn],
    body: tableRows,
    styles: { fontSize: 9 },
    headStyles: { fillColor: [22, 160, 133], textColor: 255 },
    alternateRowStyles: { fillColor: [240, 240, 240] },
    theme: "grid",
    margin: { left: 10, right: 10 },
  });

  // Pied de page
  const pageCount = doc.internal.getNumberOfPages();
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    doc.setFontSize(8);
    doc.text(`Page ${i} / ${pageCount}`, pageWidth / 2, 200, { align: "center" }); // ajusté pour paysage
  }

  // Sauvegarder
  doc.save("Anonymes_Export.pdf");
};

export default ExportPDFPro;
